import React from 'react';
//https://medium.com/@wisecobbler/using-context-in-react-56a8e7da5431
export var FormErrorContext = React.createContext({ errors: [] });
